import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

export function tempFeePay(data) {
  return new Promise((resolve, reject) => {
    data.communityId = getCommunityId()
    request({
      url: '/fee.tempFeePay',
      method: 'post',
      data
    }).then(response => {
      let res = response.data
      if (typeof res === 'string') {
        try {
          res = JSON.parse(res)
        } catch (e) {
          // ignore parse error
        }
      }
      if (res && res.code === 0) {
        resolve(res)
      } else {
        reject(new Error((res && res.msg) || '补充缴费失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
